// src/hooks/useCoachClients.js
import {useEffect, useState} from 'react';

export const useCoachClients = (authorizedHttpClient) => {
    const [clients, setClients] = useState([]);

    useEffect(() => {
        const fetchCoachClients = async () => {
            try {
                const response = await authorizedHttpClient.jsonRequest('GET', '/api/me/clients');
                console.log("Fetched clients:", response); // Debugging line
                if (response) {
                    setClients(response);
                }
            } catch (error) {
                console.error('Error fetching coach clients:', error);
            }
        };

        fetchCoachClients();
    }, [authorizedHttpClient]);

    return clients;
};
